export default __webpack_public_path__ + "static/media/academia_4.9bee3f89.jpg";